module.exports = __webpack_public_path__ + "769034b3765a7e5119fa9e668f66ea4e.png";